import '@fontsource/cabin/400.css';
import '@fontsource/cabin/500.css';
import '@fontsource/cabin/700.css';

import React from 'react';
import ReactDOM from 'react-dom/client';

import { queryClient } from 'common/queryClient';
import { clearPersistedQueryClientCache, restoreQueryClient } from 'common/offline/reactQueryPersistence';
import { syncManager } from 'common/offline/syncManager';
import { fileSyncManager } from 'common/offline/fileSyncManager';
import { initializeFromPendingUploads, subscribeToFileSyncEvents } from 'common/offline/offlinePhotoStorage';

import { App } from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

async function bootstrap() {
  try {
    await restoreQueryClient(queryClient);
  } catch (err) {
    // eslint-disable-next-line
    console.error('Failed to restore React Query cache', err);

    try {
      await clearPersistedQueryClientCache();
    } catch (clearErr) {
      // eslint-disable-next-line
      console.warn('Failed to clear persisted cache', clearErr);
    }
  } finally {
    // Initialize the sync manager for offline mutation support
    syncManager.initialize(queryClient);

    // Initialize the file sync manager for offline file uploads
    fileSyncManager.initialize(queryClient);

    // Initialize offline photo storage and subscribe to sync events
    await initializeFromPendingUploads();
    subscribeToFileSyncEvents();

    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  }
}

bootstrap();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
